import React, { Component } from 'react'
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';

export default class DateTimePicker extends Component {
  render() {
    const {props} = this
    return (
      <DatePicker
        {...props}
        className="form-control"
        minDate ={props.minDate}
        selected={props.selected}
        onChange={props.onChange}
        timeFormat="HH:mm"
        timeIntervals={60}
        dateFormat="lll"
        timeCaption="time"
        showTimeSelect
        withPortal
        readOnly
      />
    )
  }
}

DateTimePicker.propTypes = {
  selected  : PropTypes.object,
  onChange  : PropTypes.func.isRequired,
};

DateTimePicker.defaultProps = {
  selected  : null,
  minDate   : moment(),
  onChange  : () => undefined,
};



// WEBPACK FOOTER //
// ./src/App/component/DateTimePicker.js